import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {TAB_TYPE_FORM} from "~/chat/ts/data/ITab";
import {__} from "~/ts/library/Translate";
import SendTabButton from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/sendTab/SendTabButton.vue";

import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "SendFormTabButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SendTabButton, {
    icon: "list-ul",
    tooltip: _unref(__)('Отправить форму'),
    "tab-type-id": _unref(TAB_TYPE_FORM)
  }, null, 8, ["tooltip", "tab-type-id"]))
}
}

})